import {
  OnboardingLayout,
  OnboardingLayoutProps,
} from "../../components/OnboardingLayout";
import { Translations, i18n } from "../../i18n";

export const PasswordResetConfirmationRoute = () => {
  const props: OnboardingLayoutProps = {
    title: i18n.t(Translations.PasswordResetConfirmationRouteTitle),
    subtitle: i18n.t(Translations.PasswordResetConfirmationRouteSubtitle),
  };

  return <OnboardingLayout {...props} />;
};
